<script>
import commomUtils from '@mixins/common-utils.js'
import { zendeskActions, zendeskValidateActions, widgetActions } from '@state/helpers'
import SubHeader from '@components/sub-header'
import { mapGetters } from 'vuex'
import SlideModal from '@components/modals/slide-modal'

export default {
  name: 'OptionList',
  components: {
    SubHeader,
    SlideModal
  },
  mixins: [commomUtils()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      tags: [],
      selectedtem: '',
      showModalInfo: false,
      optionsLength: 0,
      showList: true,
      modal: {
        title: '',
        body: '',
        button: ''
      }
    }
  },
  computed: {
    ...mapGetters('widgets', ['notSatisfiedUser']),
    countryCode () {
      return this.$route.query.country_code
    },
    validationKey () {
      const { name } = this.$options

      return `${name}_${this.componentData.key}`
    },
    getIsHidden () {
      return this.componentData.isHidden
    },
    getKey() {
      return this.componentData.key
    }
  },
  watch: {
    selectedtem () {
      const { name } = this.$options

      this.commitCustomField({
        value: this.selectedtem,
        // id: this.componentData.customFieldId,
        key: this.componentData.key ? this.componentData.key : 'solution_type',
      })
      this.commitZendeskCommon({
        key: this.componentData.key ? this.componentData.key : 'solution_type',
        data: {
          title: this.componentData.title,
          value: this.selectedtem,
        },
      })

      this.commitValidatedField({
        type: 'function',
        key: this.validationKey,
        name,
      })
      this.changeVisibility()
      this.changeRequired()
    },
  },
  created () {
    if (!this.getIsHidden || undefined) {
      this.validateRequired()
    }
    this.optionsLength = this.componentData.values.length
    this.validateisHidden()
  },
  methods: {
    ...zendeskActions,
    ...zendeskValidateActions,
    ...widgetActions,
    getselectedtem () {
      return this.selectedtem
    },
    verifyKey (itemSelected) {
      if (this.isCupon(itemSelected.id)) {
        this.modal = itemSelected.modal || { id: '', body: '', button: '' }
        this.showModalInfo = true
      }
    },
    isCupon (id) {
      return id === 'reembolso_en_cupon'
    },
    validateRequired () {
      const { name } = this.$options
      this.commitRequiredFields({
        type: 'function',
        key: this.validationKey,
        name,
        message: this.$t('WIDGETS.OPTION_LIST.PLEASE_COMPLETE', {
          question: this.componentData.title
        }),
      })
    },
    validateisHidden () {
      if (!this.getIsHidden) {
        this.showList = true
      } else {
        this.showList = false
      }
    },
    changeVisibility () {
      const { evaluate = [] } = this.componentData
      let isTrue = false
      let values = null
      for (let j = 0; j < evaluate.length; j++) {
        const { toEvaluate, spected } = evaluate[j]
        values = Object.values(toEvaluate);
        isTrue = spected === this.selectedtem

        for (let i = 0; i < values.length; i++) {
          this.commitWidgetChanges({
            widgetName: values[i],
            data: {
              show: isTrue,
            },
          })
        }
      }
    },
    changeRequired () {
      const { evaluate = [] } = this.componentData
      let isTrue = false
      let values = null
      for (let j = 0; j < evaluate.length; j++) {
        const { toEvaluate, spected } = evaluate[j]
        values = Object.values(toEvaluate);
        isTrue = spected === this.selectedtem

        for (let i = 0; i < values.length; i++) {
          this.commitRequiredFields({
            type: 'function',
            key: values[i],
            name: "Input",
            isTrue,
            evaluate: true,
            message: this.$t('WIDGETS.OPTION_LIST.PLEASE_COMPLETE', {
              question: values[i],
            }),
          })
        }
      }
    },
  }
}
</script>

<template>
  <div v-if="showList">
    <div
      v-if="notSatisfiedUser"
      :class="$style.container"
      :id="`${this.$options.name}-container`"
    >
      <SubHeader
        :class="$style.container__header"
        :text="componentData.title || $t('WIDGETS.OPTION_LIST.TITLE')"
      />

      <div
        v-for="(v, i) in componentData.values"
        :key="v.id">
        <BaseRadio
          :class="$style.container__radios"
          :value="v.id"
          v-model="selectedtem"
          :label="v.value"
          :show-info="isCupon(v.id)"
          :id="`option-${i}`"
          @showModalInfo="verifyKey(v)"
        />
        <div
          v-if="!!v.detail"
          :class="$style.container__details"
          v-html="v.detail"/>
        <div
          v-if="optionsLength > i + 1"
          :class="$style.container__divider"/>
      </div>
      <SlideModal
        :active="showModalInfo"
        :title="modal.title"
        :body="modal.body"
        :button="modal.button"
        @closeModal="showModalInfo = false"
      />
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  padding-top: 1.2rem;
  margin: 0;
  text-align: left !important;
  background-color: $background-container;

  &__header {
    margin-bottom: 1.5rem;
  }

  &__radios {
    @extend %typography-medium;

    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 1.3rem;
    font-size: 1.2rem;
    color: $secondary-text;
  }

  &__details {
    margin: 10px 15px;
    font-size: 1rem;
    font-style: italic;
  }

  &__divider {
    margin: 0 1em;
    border-bottom: 1px solid $divider-gray;
  }
}
</style>
